export default "__VITE_ASSET__a7d30881__"